import { Link } from "react-router-dom";
import { Logo } from "@/components/site/Header";
import { BUSINESS, LEGAL_LINKS, META_DISCLAIMER } from "@/data/business";
import { openCookieSettings } from "@/lib/tracking";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 pb-28 md:pb-0">
    <div className="max-w-[1400px] mx-auto px-5 sm:px-8 lg:px-12 py-16 grid md:grid-cols-12 gap-10">
      <div className="md:col-span-5 flex gap-5 items-start">
        <Logo size={64} />
        <div>
          <p className="font-display text-2xl font-extrabold tracking-tight">Elite Performance Lab</p>
          <p className="mt-2 text-sm text-slate-400">Elite football development. Adelaide, South Australia.</p>
        </div>
      </div>
      <div className="md:col-span-3 text-sm space-y-3">
        <p className="text-[11px] font-mono-epl uppercase tracking-wider text-slate-500">Information</p>
        <Link to="/privacy" className="block text-slate-300 hover:text-white" data-testid="footer-privacy-link">Privacy Policy</Link>
        {LEGAL_LINKS.slice(1).map((l) => (
          <Link key={l.to} to={l.to} className="block text-slate-300 hover:text-white" data-testid={`footer-link-${l.to.slice(1)}`}>{l.label}</Link>
        ))}
        <button onClick={openCookieSettings} className="block text-slate-300 hover:text-white" data-testid="footer-cookie-settings">Cookie settings</button>
      </div>
      <div className="md:col-span-4 text-sm space-y-2" data-testid="footer-business">
        <p className="text-[11px] font-mono-epl uppercase tracking-wider text-slate-500">Contact</p>
        <p className="text-slate-200 font-medium">{BUSINESS.name}</p>
        <p className="text-slate-400">ABN {BUSINESS.abn}</p>
        <p className="text-slate-400">{BUSINESS.address}</p>
        <p className="text-slate-300" data-testid="footer-contact">
          <a href={`mailto:${BUSINESS.email}`} className="hover:text-white transition-colors break-all" data-testid="footer-email-link">{BUSINESS.email}</a>
          {" · "}
          <a href={BUSINESS.phoneHref} className="hover:text-white transition-colors whitespace-nowrap" data-testid="footer-phone-link">{BUSINESS.phone}</a>
        </p>
      </div>
    </div>
    <div className="max-w-[1400px] mx-auto px-5 sm:px-8 lg:px-12 py-6 border-t border-white/5 flex flex-col md:flex-row justify-between gap-3 text-xs text-slate-500">
      <p>© 2026 {BUSINESS.name} trading as Elite Performance Lab. All rights reserved.</p>
      <p className="max-w-xl">Elite Performance Lab is independent and is not endorsed, operated or sponsored by UEFA. UEFA A refers to our coaches' individual qualifications.</p>
    </div>
    <p data-testid="footer-outcome-disclaimer" className="max-w-[1400px] mx-auto px-5 sm:px-8 lg:px-12 pb-4 text-xs text-slate-400 leading-relaxed">
      Disclaimer: Participation in Elite Performance Lab does not guarantee football trials, professional contracts, academy selection, scouting opportunities or future career outcomes. Our programme is focused solely on player development.
    </p>
    <p data-testid="footer-meta-disclaimer" className="max-w-[1400px] mx-auto px-5 sm:px-8 lg:px-12 pb-8 text-[11px] text-slate-500 leading-relaxed">{META_DISCLAIMER}</p>
  </footer>
);
